module.exports = __webpack_public_path__ + "img/71.4c12cdb7.jpg";